export default __webpack_public_path__ + "static/media/burnBubble.af10dcb6.png";